import React, { useContext } from "react";
import globalContext from "../Hooks/globalContext";

export const languageAction = (index, language) => {
  switch (index) {
    case "한국어":
      return "한국어";
    case "영어":
      return "English";
    case "일본어":
      return "日本語";
    case "중국어":
      return "中國";
    case "태국어":
      return "ภาษาไทย";
    case "베트남어":
      return "Tiếng Việt";
    default:
      return "None";
  }
};

export default (index, _language, element) => {
  let language = "";

  if (_language) {
    language = { state: _language };
  } else {
    const { language: __language } = useContext(globalContext);
    language = __language;
  }

  if (language) {
    switch (language.state) {
      case "korean":
        switch (index) {
          case "로그인":
            return "로그인";
          case "홈":
            return "홈";
          case "버전":
            return "버전";
          case "내역이 없습니다.":
            return "내역이 없습니다.";
          case "회원가입":
            return "회원가입";
          case "비밀번호 찾기":
            return "비밀번호 찾기";
          case "이메일":
            return "이메일";
          case "비밀번호":
            return "비밀번호";
          case "비밀번호 확인":
            return "비밀번호 확인";
          case "돌아가기":
            return "돌아가기";
          case "더 보기":
            return "더 보기";
          case "확인":
            return "확인";
          case "약관":
            return "약관";
          case "삭제":
            return "삭제";
          case "로그아웃":
            return "로그아웃";
          case "지갑":
            return "지갑";
          case "히스토리":
            return "히스토리";
          case "출금":
            return "출금";
          case "자산":
            return "자산";
          case "잔액":
            return "잔액";
          case "수수료":
            return "수수료";
          case "가스":
            return "가스";
          case "송금":
            return "송금";
          case "별명":
            return "별명";
          case "등록":
            return "등록";
          case "지갑 주소":
            return "지갑 주소";
          case "받는 지갑주소":
            return "받는 지갑주소";
          case "보낼 금액":
            return "보낼 금액";
          case "비밀번호 변경":
            return "비밀번호 변경";
          case "추천인 코드":
            return "추천인 코드";
          case "가격":
            return "가격";
          case "패키지":
            return "패키지";
          case "보너스":
            return "보너스";
          case "설정":
            return "설정";
          case "클립보드로 복사":
            return "클립보드로 복사";
          case "보낸 항목":
            return "보낸 항목";
          case "받은 항목":
            return "받은 항목";
          case "보낼 금액을 입력하세요.":
            return "보낼 금액을 입력하세요.";
          case "수수료를 선택하세요.":
            return "수수료를 선택하세요.";
          case "나의 자산":
            return "나의 자산";
          case "빠름":
            return "빠름";
          case "보통":
            return "보통";
          case "느림":
            return "느림";
          case "받은 기부 내역":
            return "받은 기부 내역";
          case "나의 기부":
            return "나의 기부";
          case "공지사항":
            return "공지사항";
          case "출금 주소록":
            return "출금 주소록";
          case "고객센터":
            return "고객센터";
          case "별명이 너무 짧습니다.":
            return "별명이 너무 짧습니다.";
          case "등록된 지갑이 없습니다.":
            return "등록된 지갑이 없습니다.";
          case "공지사항이 없습니다.":
            return "공지사항이 없습니다.";
          case "올바른 지갑주소가 아닙니다.":
            return "올바른 지갑주소가 아닙니다.";
          case "지갑주소가 존재하지 않습니다.":
            return "지갑주소가 존재하지 않습니다.";
          case "이더를 지불할 관리자 지갑주소입니다.":
            return "이더를 지불할 관리자 지갑주소입니다.";
          case "이더 시세 기준 지불 금액입니다.":
            return "이더 시세 기준 지불 금액입니다.";
          case "받는 사람의 주소를 입력하세요.":
            return "받는 사람의 주소를 입력하세요.";
          case "개인 키를 입력하세요.":
            return "개인 키를 입력하세요.";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "개인 키는 서버에 저장되지 않습니다.";
          case "지갑 주소가 복사되었습니다.":
            return "지갑 주소가 복사되었습니다.";
          case "기록이 존재하지 않습니다.":
            return "기록이 존재하지 않습니다.";
          case "추천인 코드가 복사되었습니다.":
            return "추천인 코드가 복사되었습니다.";
          case "성공적으로 처리되었습니다.":
            return "성공적으로 처리되었습니다.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "서버 오류입니다. 잠시 후에 다시 시도해주세요.";
          case "잠시 후에 다시 시도해주세요.":
            return "잠시 후에 다시 시도해주세요.";
          case "추천인 코드를 등록했습니다.":
            return "추천인 코드를 등록했습니다.";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "이미 등록된 추천인 코드가 있습니다.";
          case "자기 자신은 등록할 수 없습니다.":
            return "자기 자신은 등록할 수 없습니다.";
          case "잔액이 부족합니다.":
            return "잔액이 부족합니다.";
          case "출금 신청이 완료되었습니다.":
            return "출금 신청이 완료되었습니다.";
          case "잘못된 요청입니다.":
            return "잘못된 요청입니다.";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "인증에 실패하였습니다. 재로그인 해주세요.";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "비밀번호가 변경되었습니다. 다시 로그인해주세요.";
          case "두 비밀번호가 맞지 않습니다.":
            return "두 비밀번호가 맞지 않습니다.";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "보안을 위해 로그아웃합니다. 다시 로그인해주세요.";
          case "출금할 금액을 입력하세요.":
            return "출금할 금액을 입력하세요.";
          case "전송 오류입니다.":
            return "전송 오류입니다.";
          case "트랜잭션 전송 완료.":
            return "트랜잭션 전송 완료.";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "시간 초과입니다. 처음부터 다시 시도해주세요.";
          case "존재하지 않는 E-Mail입니다.":
            return "존재하지 않는 E-Mail입니다.";
          case "잘못된 코드입니다.":
            return "잘못된 코드입니다.";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.";
          case "비밀번호 변경이 완료되었습니다.":
            return "비밀번호 변경이 완료되었습니다.";
          case "개인 키가 복사되었습니다.":
            return "개인 키가 복사되었습니다.";
          case "인증 번호를 전송했습니다.":
            return "인증 번호를 전송했습니다.";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "5분 안에 이메일에 전송된 코드를 입력하세요.";
          case "중복된 E-Mail입니다.":
            return "중복된 E-Mail입니다.";
          case "존재하지 않는 추천인입니다.":
            return "존재하지 않는 추천인입니다.";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "잘못된 E-Mail 혹은 비밀번호입니다.";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "당신의 지갑주소입니다. QR코드를 스캔하세요.";
          case "개인 키를 클릭하여 복사하세요.":
            return "개인 키를 클릭하여 복사하세요.";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "개인 키는 반드시 별도로 저장해주세요.";
          case "* 서버에 저장되지 않습니다. *":
            return "* 서버에 저장되지 않습니다. *";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "지갑 주소를 클릭하여 복사하세요.";
          case "약관에 동의하지 않으면 서비스를 이용할 수 없습니다.":
            return "약관에 동의하지 않으면 서비스를 이용할 수 없습니다.";
          case "알림":
            return "알림";
          case "아이디":
            return "아이디";

          case "로그 수":
            return "로그 수";
          case "검색":
            return "검색";
          case "유저 목록":
            return "유저 목록";
          case "락업 로그":
            return "락업 로그";
          case "스테이킹 로그":
            return "스테이킹 로그";
          case "설정":
            return "설정";
          case "유저를 관리합니다.":
            return "유저를 관리합니다.";
          case "락업 관련 로그를 조회합니다.":
            return "락업 관련 로그를 조회합니다.";
          case "스테이킹 관련 로그를 조회합니다.":
            return "스테이킹 관련 로그를 조회합니다.";
          case "ASK 월렛 기본 설정을 조정합니다.":
            return "ASK 월렛 기본 설정을 조정합니다.";
          case "입력값을 확인해주세요.":
            return "입력값을 확인해주세요.";
          case "변경사항이 적용되었습니다.":
            return "변경사항이 적용되었습니다.";
          case "모든 유저의 스테이킹을 차단합니다.":
            return "모든 유저의 스테이킹을 차단합니다.";
          case "모든 유저의 스테이킹을 허용합니다.":
            return "모든 유저의 스테이킹을 허용합니다.";
          case "설정 변경":
            return "설정 변경";
          case "스테이킹 가능 상태 조정":
            return "스테이킹 가능 상태 조정";
          case "스테이킹 일(Day)":
            return "스테이킹 일(Day)";
          case "스테이킹 보상 지급 비율(%)":
            return "스테이킹 보상 지급 비율(%)";
          case "최소 스테이킹 수량":
            return "최소 스테이킹 수량";
          case "변경할 관리자 지갑 주소":
            return "변경할 관리자 지갑 주소";
          case "이더 전송 수수료":
            return "이더 전송 수수료";
          case "변경":
            return "변경";
          case "총 유저 수":
            return "총 유저 수";
          case "email로 검색":
            return "email로 검색";
          case "지갑주소로 검색":
            return "지갑주소로 검색";
          case "추천인코드로 검색":
            return "추천인코드로 검색";
          case "추천인으로 검색":
            return "추천인으로 검색";
          case "번호":
            return "번호";
          case "이메일":
            return "이메일";
          case "이더지갑":
            return "이더지갑";
          case "비트지갑":
            return "비트지갑";
          case "가입일":
            return "가입일";
          case "이메일인증여부":
            return "이메일인증여부";
          case "포인트":
            return "포인트";
          case "락업중":
            return "락업중";
          case "관리":
            return "관리";
          case "입력값이 없습니다.":
            return "입력값이 없습니다.";
          case "숫자를 입력해주세요.":
            return "숫자를 입력해주세요.";
          case "충전이 완료되었습니다.":
            return "충전이 완료되었습니다.";
          case "충전할 포인트 (충전이 아닌 차감은 음수 입력)":
            return "충전할 포인트 (충전이 아닌 차감은 음수 입력)";
          case "충전":
            return "충전";
          case "전송":
            return "전송";
          case "락업":
            return "락업";
          case "락업 갯수":
            return "락업 갯수";
          case "락업 시간 (일 단위)":
            return "락업 시간 (일 단위)";
          case "삭제":
            return "삭제";
          case "지급":
            return "지급";
          case "미지급":
            return "미지급";
          case "번호":
            return "번호";
          case "락업 갯수":
            return "락업 갯수";
          case "락업 해제일":
            return "락업 해제일";
          case "스테이킹된 갯수":
            return "스테이킹된 갯수";
          case "날짜":
            return "날짜";
          case "스테이킹 해제일":
            return "스테이킹 해제일";
          case "유저 번호":
            return "유저 번호";
          case "지급 상태":
            return "지급 상태";
          case "보상 지급일":
            return "보상 지급일";
          case "정말 삭제하시겠습니까?":
            return "정말 삭제하시겠습니까?";
          case "락업이 완료되었습니다.":
            return "락업이 완료되었습니다.";
          case "유저 관리":
            return "유저 관리";

          default:
            return "None";
        }

      /**
       * *************************************************************
       */

      case "english":
        switch (index) {
          case "로그인":
            return "Login";
          case "홈":
            return "home";
          case "등록할 지갑 정보":
            return " wallet info for registration ";
          case "버전":
            return "version";
          case "내역이 없습니다.":
            return "there is no history.";
          case "회원가입":
            return "Sigh Up";
          case "비밀번호 찾기":
            return "Find Password";
          case "이메일":
            return "Email";
          case "패키지를 선택해주세요.":
            return " Select Package.";
          case "비밀번호":
            return "Password";
          case "비밀번호 확인":
            return " Confirm Password ";
          case "돌아가기":
            return "Return";
          case "더 보기":
            return "Learn More";
          case "확인":
            return "Confirm";
          case "약관":
            return "Terms and Conditions";
          case "삭제":
            return "Delete";
          case "로그아웃":
            return "Log Out";
          case "지갑":
            return "Wallet";
          case "히스토리":
            return "History";
          case "출금":
            return "Withdrawal";
          case "자산":
            return "Asset";
          case "잔액":
            return "Balance";
          case "수수료":
            return "Fee";
          case "가스":
            return "Gas";
          case "송금":
            return "Deposit";
          case "별명":
            return "Nickname";
          case "등록":
            return "Registration";
          case "지갑 주소":
            return "Wallet Address";
          case "받는 지갑주소":
            return "Wallet Address to Receive";
          case "보낼 금액":
            return "Sending Amount";
          case "비밀번호 변경":
            return "Change Password";
          case "추천인 코드":
            return "Recommender Code";
          case "기부":
            return "Donation";
          case "가격":
            return "Price";
          case "패키지":
            return "Package";
          case "보너스":
            return "Bonus";
          case "설정":
            return "Set up";
          case "클립보드로 복사":
            return "Copy as Clipboard";
          case "보낸 항목":
            return "Sending Items";
          case "받은 항목":
            return "Receiving Items";
          case "보낼 금액을 입력하세요.":
            return "Enter amount to send.";
          case "수수료를 선택하세요.":
            return "Select Fee.";
          case "나의 자산":
            return "My Asset";
          case "빠름":
            return "Fast";
          case "보통":
            return "Normal";
          case "느림":
            return "Slow";
          case "받은 기부 내역":
            return "List of Received Donation";
          case "나의 기부":
            return "My Donation";
          case "공지사항":
            return "Notice";
          case "출금 주소록":
            return "Withdrawal Address Book";
          case "고객센터":
            return "Customer Center";
          case "별명이 너무 짧습니다.":
            return "Nickname is too short.";
          case "등록된 지갑이 없습니다.":
            return "No registered wallet ";
          case "공지사항이 없습니다.":
            return "No Notice";
          case "올바른 지갑주소가 아닙니다.":
            return "Check correct wallet address.";
          case "지갑주소가 존재하지 않습니다.":
            return "No wallet address existed.";
          case "이더를 지불할 관리자 지갑주소입니다.":
            return "Administrator wallet address to pay ETH.";
          case "이더 시세 기준 지불 금액입니다.":
            return "Current ETH payment";
          case "받는 사람의 주소를 입력하세요.":
            return "Enter the address to send";
          case "개인 키를 입력하세요.":
            return "Enter your personal key.";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "Your personal key won’t save to server.";
          case "지갑 주소가 복사되었습니다.":
            return "Wallet address was copied ";
          case "기록이 존재하지 않습니다.":
            return "No record existed.";
          case "추천인 코드가 복사되었습니다.":
            return "Recommender code was copied.";
          case "패키지에 기부하였습니다.":
            return "Donated to package successfully";
          case "성공적으로 처리되었습니다.":
            return "Complete successfully.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "Server error. Please try again later.";
          case "잠시 후에 다시 시도해주세요.":
            return "Please try again later.";
          case "추천인 코드를 등록했습니다.":
            return "Recommender code was registered.";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "The recommender code was already registered.";
          case "자기 자신은 등록할 수 없습니다.":
            return "You can’t recommend yourself.";
          case "잔액이 부족합니다.":
            return "Not enough balance.";
          case "출금 신청이 완료되었습니다.":
            return "Withdrawal request was completed.";
          case "잘못된 요청입니다.":
            return "Wrong request.";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "Failed verification Please log in again.";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "Wrong password. Please check it and try again";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "Password was changed Please log in again.";
          case "두 비밀번호가 맞지 않습니다.":
            return "2 passwords aren’t correct.";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "Log out for security reason. Please log in again.";
          case "출금할 금액을 입력하세요.":
            return "Enter amount to withdraw.";
          case "전송 오류입니다.":
            return "Sending error";
          case "트랜잭션 전송 완료.":
            return "Complete to send transaction.";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "Time Out. Please try again.";
          case "존재하지 않는 E-Mail입니다.":
            return "Not registered E-mail ";
          case "잘못된 코드입니다.":
            return "Wrong code";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "Complete E-mail verification. Check wallet information";
          case "비밀번호 변경이 완료되었습니다.":
            return "Complete changing password.";
          case "지갑 주소가 복사되었습니다.":
            return "Wallet address was copied.";
          case "개인 키가 복사되었습니다.":
            return "Your personal key was copied";
          case "존재하지 않는 E-Mail입니다.":
            return "Not registered E-mail ";
          case "잘못된 코드입니다.":
            return "Wrong code";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "Complete E-mail verification. Check wallet information";
          case "비밀번호 변경이 완료되었습니다.":
            return "Complete changing password.";
          case "지갑 주소가 복사되었습니다.":
            return "Wallet address was copied.";
          case "개인 키가 복사되었습니다.":
            return "Your personal key was copied";
          case "인증 번호를 전송했습니다.":
            return "Verification code was sent";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "Enter verification code sent to your e-mail within 5 minutes";
          case "중복된 E-Mail입니다.":
            return "Duplicated e-mail";
          case "존재하지 않는 추천인입니다.":
            return "Not registered recommender";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "Wrong e-mail or password.";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "This is your wallet address. Please scan QR code.";
          case "개인 키를 클릭하여 복사하세요.":
            return "Click and copy your personal key";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "Be sure to save your personal key separately";
          case "* 서버에 저장되지 않습니다. *":
            return "* It’s not saved on server *";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "Click and copy wallet address.";
          case "약관에 동의하지 않으면 서비스를 이용할 수 없습니다.":
            return "Be sure to agree terms and conditions first before using the service";
          case "알림":
            return "Notice";
          case "아이디":
            return "ID";

          /*** */
          case "로그 수":
            return "Number of Logs";
          case "검색":
            return "Search";
          case "유저 목록":
            return "User List";
          case "락업 로그":
            return "Lock-up Logs";
          case "스테이킹 로그":
            return "Staking Logs";
          case "설정":
            return "Settings";
          case "유저를 관리합니다.":
            return "User Management";
          case "락업 관련 로그를 조회합니다.":
            return "Search lock-up logs";
          case "스테이킹 관련 로그를 조회합니다.":
            return "Search staking logs";
          case "ASK 월렛 기본 설정을 조정합니다.":
            return "ASK Wallet basic setting adjustment.";
          case "입력값을 확인해주세요.":
            return "Please check the input value";
          case "변경사항이 적용되었습니다.":
            return "Changes have been applied.";
          case "모든 유저의 스테이킹을 차단합니다.":
            return "Block all users from staking.";
          case "모든 유저의 스테이킹을 허용합니다.":
            return "Allow all users to Stake.";
          case "설정 변경":
            return "Change Settings";
          case "스테이킹 가능 상태 조정":
            return "Adjust staking status";
          case "스테이킹 일(Day)":
            return "Staking Day";
          case "스테이킹 보상 지급 비율(%)":
            return "Staking Reward Rate (%)";
          case "최소 스테이킹 수량":
            return "Minimum Staked Quantity";
          case "변경할 관리자 지갑 주소":
            return "Change admin wallet address";
          case "이더 전송 수수료":
            return " Ethereum transfer fee(Gas)";
          case "변경":
            return "Change";
          case "총 유저 수":
            return "Total number of users";
          case "email로 검색":
            return "Search by E-mail";
          case "지갑주소로 검색":
            return "Search by Wallet Address";
          case "추천인코드로 검색":
            return "Search by referral code";
          case "추천인으로 검색":
            return "Search by referral";
          case "번호":
            return "Number";
          case "이메일":
            return "Email";
          case "이더지갑":
            return "Ethereum Wallet";
          case "비트지갑":
            return "Bitcoin Wallet";
          case "가입일":
            return "Signup date";
          case "이메일인증여부":
            return " Email verification";
          case "포인트":
            return "Points";
          case "락업중":
            return "Locking up";
          case "관리":
            return "Admin";
          case "입력값이 없습니다.":
            return "There is no input value. ";
          case "숫자를 입력해주세요.":
            return "Please enter a number.";
          case "충전이 완료되었습니다.":
            return "Charging is complete.";
          case "충전할 포인트 (충전이 아닌 차감은 음수 입력)":
            return "Point to recharge (Enter a negative number for subtraction)";
          case "충전":
            return "Charge";
          case "전송":
            return "Withdraw";
          case "락업":
            return "Lock-up";
          case "락업 갯수":
            return "Locked-up number";
          case "락업 시간 (일 단위)":
            return " Lockup time (in days) ";
          case "삭제":
            return "Delete";
          case "지급":
            return " Payments";
          case "미지급":
            return " Unpaid ";
          case "번호":
            return "Number";
          case "락업 갯수":
            return "Locked-up number ";
          case "락업 해제일":
            return "Lock-up release date ";
          case "스테이킹된 갯수":
            return "Staked number";
          case "날짜":
            return "Date";
          case "스테이킹 해제일":
            return "Staking release date ";
          case "유저 번호":
            return "User number";
          case "지급 상태":
            return "Payment status ";
          case "보상 지급일":
            return "Compensation payment date ";
          case "정말 삭제하시겠습니까?":
            return "Please confirm your delete request. ";
          case "유저 관리":
            return "User Management";

          default:
            return "None";
        }

      /**
       * *************************************************************
       */
      case "chinese":
        switch (index) {
          case "로그인":
            return "登录";
          case "홈":
            return "主页";
          case "등록할 지갑 정보":
            return " 登记钱包信息 ";
          case "버전":
            return "版本";
          case "내역이 없습니다.":
            return "无相关内容.";
          case "회원가입":
            return "注册";
          case "비밀번호 찾기":
            return "找回密码";
          case "이메일":
            return "电子邮件";
          case "패키지를 선택해주세요.":
            return "请选择配套.";
          case "비밀번호":
            return "密码";
          case "비밀번호 확인":
            return "确定密码";
          case "추천인":
            return "推荐人";
          case "돌아가기":
            return "返回";
          case "더 보기":
            return "查看更多";
          case "확인":
            return "确定";
          case "약관":
            return "条款";
          case "삭제":
            return "删除";
          case "로그아웃":
            return "退出";
          case "지갑":
            return "钱包";
          case "히스토리":
            return "历史";
          case "출금":
            return "提现";
          case "자산":
            return "资产";
          case "잔액":
            return "余额";
          case "수수료":
            return "手续费";
          case "가스":
            return "气体";
          case "송금":
            return "转账";
          case "별명":
            return "别名";
          case "등록":
            return "上传";
          case "지갑 주소":
            return "钱包地址";
          case "받는 지갑주소":
            return "收款钱包地址";
          case "보낼 금액":
            return "转账金额";
          case "비밀번호 변경":
            return "更改密码";
          case "추천인 코드":
            return "推荐人代码";
          case "가격":
            return "价格";
          case "패키지":
            return "套餐";
          case "보너스":
            return "奖励";
          case "설정":
            return "设置";
          case "클립보드로 복사":
            return "复制至剪贴板";
          case "보낸 항목":
            return "已发送项目";
          case "받은 항목":
            return "已接受项目";
          case "보낼 금액을 입력하세요.":
            return "请输入转账金额.";
          case "수수료를 선택하세요.":
            return "请选择手续费.";
          case "나의 자산":
            return "我的资产";
          case "빠름":
            return "迅速";
          case "보통":
            return "普通";
          case "느림":
            return "缓慢";
          case "받은 기부 내역":
            return "已收到的捐款明细";
          case "나의 기부":
            return "我的捐款";
          case "공지사항":
            return "公告事项";
          case "출금 주소록":
            return "提现通信录";
          case "고객센터":
            return "客服中心";
          case "별명이 너무 짧습니다.":
            return "昵称太短了.";
          case "등록된 지갑이 없습니다.":
            return "不存在登记的钱包.";
          case "공지사항이 없습니다.":
            return "无公告事项.";
          case "올바른 지갑주소가 아닙니다.":
            return "错误的钱包地址.";
          case "지갑주소가 존재하지 않습니다.":
            return "钱包地址不存在.";
          case "이더를 지불할 관리자 지갑주소입니다.":
            return "这是支付以太坊的管理员的钱包地址.";
          case "이더 시세 기준 지불 금액입니다.":
            return "按以太坊行情标准支付的金额.";
          case "받는 사람의 주소를 입력하세요.":
            return "请输入收款人的地址.";
          case "개인 키를 입력하세요.":
            return "请输入个人密钥.";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "个人蜜月额未保存在服务器上.";
          case "지갑 주소가 복사되었습니다.":
            return "钱包地址已复制.";
          case "기록이 존재하지 않습니다.":
            return "记录不存在.";
          case "추천인 코드가 복사되었습니다.":
            return "推荐人代码已复制.";
          case "성공적으로 처리되었습니다.":
            return "已成功受理.";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "服务器错误.请稍候再试.";
          case "잠시 후에 다시 시도해주세요.":
            return "请稍候再试.";
          case "추천인 코드를 등록했습니다.":
            return "已登记推荐人代码.";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "存在已登记的推荐人代码.";
          case "자기 자신은 등록할 수 없습니다.":
            return "无法登记自己本人.";
          case "잔액이 부족합니다.":
            return "无法登记本人.";
          case "출금 신청이 완료되었습니다.":
            return "提现申请完成.";
          case "잘못된 요청입니다.":
            return "错误的请求。.";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "验证失败.请重新登录.";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "密码错误.请重新登录.";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "密码已更改.请重新登录.";
          case "두 비밀번호가 맞지 않습니다.":
            return "两个密码不同.";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "为保障系统账号完全已退出.请重新登录.";
          case "출금할 금액을 입력하세요.":
            return "请输入提现金额.";
          case "전송 오류입니다.":
            return "传送错误.";
          case "트랜잭션 전송 완료.":
            return "交易传送完成.";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "超时.请从头重试.";
          case "존재하지 않는 E-Mail입니다.":
            return "不存在的E-Mail.";
          case "잘못된 코드입니다.":
            return "错误的代码.";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "邮箱验证完成.请确认钱包信息.";
          case "비밀번호 변경이 완료되었습니다.":
            return "密码更改完成.";
          case "개인 키가 복사되었습니다.":
            return "个人密钥复制.";
          case "인증 번호를 전송했습니다.":
            return "验证号码已发送.";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "请5分钟之内输入邮箱收到的代码.";
          case "중복된 E-Mail입니다.":
            return "重复的E-Mail.";
          case "존재하지 않는 추천인입니다.":
            return "推荐人不存在.";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "E-Mail或密码.";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "您的钱包地址.请刷QR码.";
          case "개인 키를 클릭하여 복사하세요.":
            return "请点击个人密钥并复制.";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "请务必另外保存个人密钥.";
          case "* 서버에 저장되지 않습니다. *":
            return "* 未保存在服务器. *";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "请点击钱包地址并复制.";
          case "약관에 동의하지 않으면 서비스를 이용할 수 없습니다.":
            return "若不同意条款将无法使用服务.";
          case "알림":
            return "提示";
          case "아이디":
            return "用户名";
          default:
            return "None";
        }
      case "japanese":
        switch (index) {
          case "로그인":
            return "ログイン";
          case "홈":
            return "ホーム";
          case "등록할 지갑 정보":
            return "登録する財布の情報";
          case "버전":
            return "バージョン";
          case "내역이 없습니다.":
            return "履歴がありません";
          case "회원가입":
            return "会員登録";
          case "비밀번호 찾기":
            return "パスワード確認";
          case "이메일":
            return "メールアドレス";
          case "패키지를 선택해주세요.":
            return "パッケージを選んでください";
          case "비밀번호":
            return "パスワード";
          case "비밀번호 확인":
            return "パスワード再確認";
          case "추천인":
            return "推薦者";
          case "돌아가기":
            return "戻る";
          case "더 보기":
            return "もっと見る";
          case "확인":
            return "確認";
          case "약관":
            return "約款";
          case "삭제":
            return "削除";
          case "로그아웃":
            return "ログアウト";
          case "지갑":
            return "財布";
          case "히스토리":
            return "ヒストリー";
          case "출금":
            return "出金";
          case "자산":
            return "資産";
          case "잔액":
            return "残額";
          case "수수료":
            return "手数料";
          case "가스":
            return "ガス";
          case "송금":
            return "送金";
          case "별명":
            return "ニックネーム";
          case "등록":
            return "登録";
          case "지갑 주소":
            return "財布の住所";
          case "받는 지갑주소":
            return "受け取る財布の住所";
          case "보낼 금액":
            return "送金額";
          case "비밀번호 변경":
            return "パスワード変更";
          case "추천인 코드":
            return "推薦者のコード";
          case "가격":
            return "価格";
          case "패키지":
            return "パッケージ";
          case "보너스":
            return "ボーナス";
          case "설정":
            return "設定";
          case "클립보드로 복사":
            return "クリップボードにコピー";
          case "보낸 항목":
            return "送った項目";
          case "받은 항목":
            return "もらった項目";
          case "보낼 금액을 입력하세요.":
            return "送金額を入力してください";
          case "수수료를 선택하세요.":
            return "手数料を選んでください";
          case "나의 자산":
            return "私の資産";
          case "빠름":
            return "速い";
          case "보통":
            return "普通";
          case "느림":
            return "遅い";
          case "받은 기부 내역":
            return "受け取った寄付の履歴";
          case "나의 기부":
            return "私の寄付";
          case "공지사항":
            return "告知";
          case "출금 주소록":
            return "出金住所録";
          case "고객센터":
            return "顧客センター";
          case "별명이 너무 짧습니다.":
            return "ニックネームが短すぎます";
          case "등록된 지갑이 없습니다.":
            return "登録された財布がありません";
          case "공지사항이 없습니다.":
            return "告知がありません";
          case "올바른 지갑주소가 아닙니다.":
            return "財布の住所が正しくありません";
          case "지갑주소가 존재하지 않습니다.":
            return "存在しない財布の住所です";
          case "이더를 지불할 관리자 지갑주소입니다.":
            return "イーサを支払う管理者財布の住所です";
          case "이더 시세 기준 지불 금액입니다.":
            return "イーサの相場による支払金額です";
          case "받는 사람의 주소를 입력하세요.":
            return "受け取る人の住所を入力してください";
          case "개인 키를 입력하세요.":
            return "パーソナルキーを入力してください";
          case "개인 키는 서버에 저장되지 않습니다.":
            return "パーソナルキーはサーバーに保存されません";
          case "지갑 주소가 복사되었습니다.":
            return "財布の住所をコピーしました";
          case "기록이 존재하지 않습니다.":
            return "記録が存在しません";
          case "추천인 코드가 복사되었습니다.":
            return "推薦者コードをコピーしました";
          case "성공적으로 처리되었습니다.":
            return "処理に成功しました";
          case "서버 오류입니다. 잠시 후에 다시 시도해주세요.":
            return "サーバーエラーです。後でまたトライしてください";
          case "잠시 후에 다시 시도해주세요.":
            return "後でまたトライしてください";
          case "추천인 코드를 등록했습니다.":
            return "推薦者コードを登録しました";
          case "이미 등록된 추천인 코드가 있습니다.":
            return "すでに登録された推薦者コードがあります";
          case "자기 자신은 등록할 수 없습니다.":
            return "自分自身は登録できません";
          case "잔액이 부족합니다.":
            return "残額が足りません";
          case "출금 신청이 완료되었습니다.":
            return "出金を申請しました";
          case "잘못된 요청입니다.":
            return "間違った操作です";
          case "인증에 실패하였습니다. 재로그인 해주세요.":
            return "認証に失敗しました。再ログインしてください";
          case "잘못된 비밀번호입니다. 확인 후 다시 시도해주세요.":
            return "パスワードが間違っています。確認後またトライしてください";
          case "비밀번호가 변경되었습니다. 다시 로그인해주세요.":
            return "パスワードが変更されました。再ログインしてください";
          case "두 비밀번호가 맞지 않습니다.":
            return "2つのパスワードが合っていません";
          case "보안을 위해 로그아웃합니다. 다시 로그인해주세요.":
            return "セキュリティにためにログアウトします。再ログインしてください";
          case "출금할 금액을 입력하세요.":
            return "出金額を入力してください";
          case "전송 오류입니다.":
            return "転送エラーです";
          case "트랜잭션 전송 완료.":
            return "トランザクションの転送が完了しました";
          case "시간 초과입니다. 처음부터 다시 시도해주세요.":
            return "タイムアウトです。最初からもう一度トライしてください";
          case "존재하지 않는 E-Mail입니다.":
            return "存在しないE-Mailです";
          case "잘못된 코드입니다.":
            return "間違ったコードです";
          case "메일 인증이 완료되었습니다. 지갑정보를 확인하세요.":
            return "メールが認証されました。財布の情報を確認してください";
          case "비밀번호 변경이 완료되었습니다.":
            return "パスワードが変更されました";
          case "개인 키가 복사되었습니다.":
            return "パーソナルキーをコピーしました";
          case "인증 번호를 전송했습니다.":
            return "認証番号を送りました";
          case "5분 안에 이메일에 전송된 코드를 입력하세요.":
            return "5分内にメールの中のコードを入力してください";
          case "중복된 E-Mail입니다.":
            return "E-Mailが中腹しています";
          case "존재하지 않는 추천인입니다.":
            return "存在しない推薦者です";
          case "잘못된 E-Mail 혹은 비밀번호입니다.":
            return "間違ったE-Mailまたはパスワードです";
          case "당신의 지갑주소입니다. QR코드를 스캔하세요.":
            return "あなたの財布の住所です。QRコードを読み取ってください";
          case "개인 키를 클릭하여 복사하세요.":
            return "パーソナルキーをクリックしてコピーします";
          case "개인 키는 반드시 별도로 저장해주세요.":
            return "パーソナルキーは必ず別途で保存してください";
          case "* 서버에 저장되지 않습니다. *":
            return "* サーバーに保存されません *";
          case "지갑 주소를 클릭하여 복사하세요.":
            return "財布の住所をクリックしてコピーします";
          case "약관에 동의하지 않으면 서비스를 이용할 수 없습니다.":
            return "約款に同意しないとサービスが利用できません";
          case "알림":
            return "お知らせ";
          case "아이디":
            return "ID";
          default:
            return "None";
        }

      default:
        return "None";
    }
  }
};
